import {
  TrendingUp
} from "lucide-react";

export default function StatCard({

  title,
  value,
  icon: Icon,
  color = "bg-primary",
  growth = "+12%"
}) {

  return (

    <div
      className="
      bg-white
      rounded-3xl
      p-6
      shadow-sm
      border
      border-gray-100
      hover:shadow-xl
      transition-all
      duration-300
    "
    >

      {/* TOP */}

      <div
        className="
        flex
        items-start
        justify-between
      "
      >

        {/* LEFT */}

        <div>

          <p
            className="
            text-sm
            text-gray-500
            font-medium
          "
          >
            {title}
          </p>

          <h2
            className="
            text-4xl
            font-bold
            mt-3
            text-gray-800
          "
          >
            {value}
          </h2>

        </div>

        {/* ICON */}

        <div
          className={`
            w-14
            h-14
            rounded-2xl
            flex
            items-center
            justify-center
            text-white
            shadow-lg
            ${color}
          `}
        >

          <Icon size={28} />

        </div>

      </div>

      {/* FOOTER */}

      <div
        className="
        mt-6
        flex
        items-center
        gap-2
      "
      >

        <TrendingUp
          size={18}
          className="
          text-green-500
        "
        />

        <span
          className="
          text-green-600
          font-semibold
          text-sm
        "
        >
          {growth}
        </span>

        <span
          className="
          text-gray-400
          text-sm
        "
        >
          vs last month
        </span>

      </div>

    </div>
  );
}